
const formList = {
    tmscoldChainList: [
        {
            entityField: "start",
            fieldType: "date1",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "开始时间",
        },
        {
            entityField: "end",
            fieldType: "date1",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "结束时间",
        },
        {
            entityField: "receiveName",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "客户名称",
        },
        {
            entityField: "productName",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "商品名称",
        },
        {
            entityField: "lcType",
            fieldType: "radioButton",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "变更类型",
        },
        {
            entityField: "orderCode",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "订单号",
        },
    ],
   
    
}
export default formList